import React from 'react';
import { faEdit } from '@fortawesome/free-solid-svg-icons';

import Icon from './Icon';

const EditIcon = ({ toolTipText = 'Edit' }) => (
  <Icon tooltip={toolTipText} iconObj={faEdit} />
);

export default EditIcon;